import {
  formatAlteracoes,
  HISTORICO_VER_SIMULACAO,
  rotuloStatusHistorico,
} from "@/modules/recursos/simulacao";
import type { SimulacaoResumoApi } from "@/modules/recursos/simulacao.gateway";
import { formatAuditDateTime } from "@/shared/components/audit-date-time/audit-date-time";

import type { HistoricoLinha } from "./types-historico-simulacao-dialog";

const SEM_VALOR = "—";
const JUSTIFICATIVA_MAX = 48;

function formatHistoricoData(iso: string | null): string {
  if (!iso) return SEM_VALOR;
  const { date, time } = formatAuditDateTime(iso);
  return time ? `${date} ${time}` : date;
}

function truncar(texto: string | null, max = JUSTIFICATIVA_MAX): string {
  if (!texto?.trim()) return SEM_VALOR;
  const limpo = texto.trim();
  return limpo.length <= max ? limpo : `${limpo.slice(0, max - 1)}…`;
}

export function toHistoricoLinha(registro: SimulacaoResumoApi): HistoricoLinha {
  const status = rotuloStatusHistorico(registro.status);
  return {
    id: registro.id,
    criada: formatHistoricoData(registro.createdAt),
    usuario: registro.usuarioNome?.trim() || SEM_VALOR,
    status,
    alteracoes: formatAlteracoes(registro.qtdAlteracoes),
    aplicada: formatHistoricoData(registro.aplicadaEm),
    justificativa: truncar(registro.justificativa),
    verLabel: `${HISTORICO_VER_SIMULACAO} ${status}`,
  };
}
